module.exports = __webpack_public_path__ + "static/media/img1.1f2324ac.png";